import { useSelectedUploadData } from './useSelectedUploadData';

/**
 *
 * @returns {string} Empty string when no record is resolved yet.
 */
export const useRecordFileName = () => {
  const { recordType, record } = useSelectedUploadData();

  if (recordType === '') return '';

  const name = record?.collection_name || record?.document_name || '';
  if (recordType === 'COLLECTION') return name;

  const parts = name.split('.');
  if (parts.length > 1) parts.pop();
  return parts.join('.');
};
